(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-product-list"] && !Shopify.designMode) return;
  try {
    	
  (function () {
    if (customElements.get('tabbed-collection')) return;

    class TabbedCollection extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = this.querySelectorAll('[role="tabpanel"]');

        if (!this.tabs.length || !this.panels.length) return;

        this.heroWrapper = this.findAssociatedHero();
        this.heroDesktop = this.heroWrapper?.querySelector('.hero__image--desktop') || null;
        this.heroMobile = this.heroWrapper?.querySelector('.hero__image--mobile') || null;

        this.defaultImages = {
          desktop: this.heroDesktop
            ? { src: this.heroDesktop.src, srcset: this.heroDesktop.srcset }
            : null,
          mobile: this.heroMobile
            ? { src: this.heroMobile.src, srcset: this.heroMobile.srcset }
            : null,
        };

        this.addEventListener('click', this.onTabClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onTabClick);
      }

      onTabClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        if (tab.hasAttribute('disabled')) return;

        this.activate(tab.dataset.tabIndex, tab);
      };

      findAssociatedHero() {
        let section = this.closest('.ui-test-product-list');
        while (section?.previousElementSibling) {
          section = section.previousElementSibling;
          const hero = section.querySelector('.hero');
          if (hero) return hero;
        }
        return null;
      }

      activate(index, tab) {
        this.tabs.forEach(t => {
          t.setAttribute('aria-selected', String(t.dataset.tabIndex === index));
        });
        this.panels.forEach(panel => {
          panel.hidden = panel.dataset.panelIndex !== index;
        });

        this.updateHero(tab);
      }

      updateHero(tab) {
        if (!this.heroWrapper) return;

        const desktop = tab.dataset.heroDesktopSrc;
        const mobile = tab.dataset.heroMobileSrc;
        if (!desktop && !mobile) {
          this.restoreDefaultImages();
          return;
        }

        if (this.heroDesktop && desktop) {
          this.swapImage(this.heroDesktop, desktop);
        }

        if (this.heroMobile && mobile) {
          this.swapImage(this.heroMobile, mobile);
        }
      }

      restoreDefaultImages() {
        const { desktop, mobile } = this.defaultImages;

        if (this.heroDesktop && desktop) {
          this.heroDesktop.src = desktop.src;
          this.heroDesktop.srcset = desktop.srcset;
        }

        if (this.heroMobile && mobile) {
          this.heroMobile.src = mobile.src;
          this.heroMobile.srcset = mobile.srcset;
        }
      }

      swapImage(img, srcset) {
        if (img.srcset === srcset) return;
        const firstSrc = srcset.split(',')[0]?.trim().split(' ')[0];
        if (firstSrc) img.src = firstSrc;

        img.srcset = srcset;
      }
    }

    customElements.define('tabbed-collection', TabbedCollection);

  })();

  } catch(e) { console.error(e); }
})();
})();
